/**
 * A task's attachments — Aaron, Oct 26 ("there needs to be an attachments
 * section. I would suggest showing the first few and if they upload a ton of
 * documents, have an expand message to show the rest so we don't clutter up
 * the primary task screen"); `docs/activity.md` §8.7.
 *
 * The files hang off the task through `file_links.activity_id` (0056) and go
 * up through `upload`, the product's one way in. The limits, the fold and the
 * History's words, said once for both sides.
 */
import { z } from 'zod';
import { FILE_TYPES, FILE_VISIBILITIES } from '../records.js';
/** How many the sheet draws before *Show N more* — "the first few". */
export const TASK_FILES_SHOWN = 3;
/** A task holds up to this many — a ton, not a file share. */
export const MAX_TASK_FILES = 100;
/**
 * What a new task may carry as it is made: the create body's `fileIds`
 * (`activityInputSchema`, `/activity/team-items`) take twenty. More can be
 * added once it exists.
 */
export const NEW_TASK_MAX_FILES = 20;
export const tooManyTaskFilesWords = (max = MAX_TASK_FILES) => max === NEW_TASK_MAX_FILES
    ? `A new task can carry up to ${max} files. Add the rest once it is made.`
    : `A task can hold up to ${max} files.`;
/** *Show 4 more* · *Show fewer* — the fold under the first few. */
export function taskFilesFoldWords(total, open, shown = TASK_FILES_SHOWN) {
    if (total <= shown)
        return null;
    return open ? 'Show fewer' : `Show ${total - shown} more`;
}
/** *PDF · 240 KB* — what a row says beside the name. */
export function taskFileMeta(name, contentType, bytes) {
    const dot = name.lastIndexOf('.');
    const extension = dot > 0 && dot < name.length - 1 ? name.slice(dot + 1) : '';
    const kind = extension && extension.length <= 5
        ? extension.toUpperCase()
        : contentType.startsWith('image/') ? 'Photo' : contentType.startsWith('video/') ? 'Video' : 'File';
    return `${kind} · ${fileSizeWords(bytes)}`;
}
/** *880 bytes* · *240 KB* · *3.4 MB*. */
export function fileSizeWords(bytes) {
    if (bytes < 1024)
        return `${bytes} bytes`;
    if (bytes < 1024 * 1024)
        return `${Math.round(bytes / 1024)} KB`;
    const mb = bytes / (1024 * 1024);
    return `${mb < 10 ? mb.toFixed(1) : Math.round(mb)} MB`;
}
/**
 * The History's line (Aaron, Oct 26): *Tom added a file — Front walkway.pdf*,
 * *Maya removed a file — Old quote.pdf*; several at once by one person are
 * one line, *Tom added 4 files*, so a pile of documents does not bury the
 * rest of the task's history.
 */
export function taskFileHistoryWords(who, change, names) {
    if (names.length === 1)
        return `${who} ${change} a file — ${names[0]}`;
    return `${who} ${change} ${names.length} files`;
}
/** `POST /activity/tasks/:id/files` — the body `useRecordUpload` already sends to a record. */
export const taskFileAttachSchema = z.object({
    fileId: z.string().uuid(),
    type: z.enum(FILE_TYPES).optional(),
    visibility: z.enum(FILE_VISIBILITIES).optional(),
});
//# sourceMappingURL=task-files.js.map